export enum StopKind {
	BOARDING = 'BA',
	BORDER = 'BR',
	CRUISING = 'CR',
	DROP_OFF = 'DO',
	TARGET = 'TG',
}

export enum VehicleTypes {
	REAL = '4,3,2',
	VIRTUAL = '5',
}
